var React = require('react');

function CloseHamburger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 1L1 19","stroke":"#111111","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19 19L1 1","stroke":"#111111","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseHamburger.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseHamburger;

CloseHamburger.default = CloseHamburger;
